import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turnstile"
export default class extends Controller {
  static targets = ["form", "error"];

  connect() {
    // Reset Turnstile widget when the form is submitted with errors
    if (this.hasErrorTarget && this.errorTarget.textContent.includes("robot")) {
      this.resetTurnstile();
    }

    // Set up a callback for when Turnstile is rendered
    window.onTurnstileCallback = this.onTurnstileCallback.bind(this);

    // Add a MutationObserver to detect when Turnstile adds the response input
    this.setupTurnstileObserver();
  }

  setupTurnstileObserver() {
    // Create a MutationObserver to watch for changes to the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          // Check if the cf-turnstile-response input has been added
          const turnstileResponse = document.querySelector('[name="cf-turnstile-response"]');
          if (turnstileResponse && turnstileResponse.value) {
            // Notify password validation controller
            this.notifyPasswordValidation();
          }
        }
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });
  }

  onTurnstileCallback() {
    // This is called when Turnstile is successfully completed
    this.notifyPasswordValidation();
  }

  notifyPasswordValidation() {
    // Find the password validation controller and trigger an update
    const passwordValidationController = this.application.getControllerForElementAndIdentifier(
      this.element,
      "password-validation"
    );

    if (passwordValidationController) {
      passwordValidationController.updateSubmitButton();
    }
  }

  resetTurnstile() {
    // Reset all Turnstile widgets on the page
    if (window.turnstile) {
      window.turnstile.reset();
    }
  }

  // Called when the form is submitted
  beforeSubmit(event) {
    // Check if Turnstile response is present
    const turnstileResponse = document.querySelector('[name="cf-turnstile-response"]');
    if (!turnstileResponse || !turnstileResponse.value) {
      event.preventDefault();

      // Show error message
      if (this.hasErrorTarget) {
        this.errorTarget.innerHTML = `
          <div class="flex">
            <div class="flex-shrink-0">
              <i class="fas fa-exclamation-circle text-red-400"></i>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                Please fix the following errors:
              </h3>
              <div class="mt-2 text-sm text-red-700">
                <ul class="list-disc pl-5 space-y-1">
                  <li>Please complete the Turnstile challenge</li>
                </ul>
              </div>
            </div>
          </div>
        `;
        this.errorTarget.classList.remove("hidden");
      }

      // Reset Turnstile widget
      this.resetTurnstile();
    }
  }
}
